import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IconDefinition, faPaperclip, faTrash } from '@fortawesome/pro-duotone-svg-icons';
import { Store } from '@ngxs/store';
import { FileInfo, RemoveEvent, SelectEvent, UploadComponent } from '@progress/kendo-angular-upload';
import _ from 'lodash';
import { Observable, of } from 'rxjs';
import { arrayBufferToBase64 } from 'src/app/helper/byteFormattingHelper';
import { WellKnownIconsEnum } from 'src/app/helper/iconHelper';
import { EmailAttachmentAdded, EmailAttachmentRemoved } from 'src/app/store/samwin/email/email-behaviour/email-behaviour.actions';
import { Attachment } from 'src/generated/swagger';

@Component({
   selector: 'samweb-attachment-upload-bar',
   templateUrl: './attachment-upload-bar.component.html',
   styleUrls: ['./attachment-upload-bar.component.scss'],
})
export class AttachmentUploadBarComponent implements OnInit {
   @Input()
   public attachments: Attachment[];

   @Input()
   public attachmentDisplayLimit = 6;

   @Input()
   public messageId: string;

   @Input()
   public isInvalid: boolean;

   @Output()
   public uploadCanceled = new EventEmitter();

   public uploadIcon: IconDefinition = faPaperclip;

   public deleteIcon: IconDefinition = faTrash;

   public clearIcon: IconDefinition = WellKnownIconsEnum.CLEAR.iconSmall;

   public displayOtherAttachments = false;

   public dropZoneHovered$: Observable<boolean> = of(false);

   public counter = 0;

   constructor(public store: Store) {}

   ngOnInit() {}

   openAttachmentDialog() {
      this.displayOtherAttachments = true;
   }

   closeAttachmentDialog() {
      this.displayOtherAttachments = false;
   }

   deleteAttachment(attachment: Attachment) {
      if (!_.isNil(attachment?.uId)) {
         this.store.dispatch(new EmailAttachmentRemoved(attachment.uId, this.messageId));
      }
   }

   removeAttachments() {
      this.attachments.forEach((file: Attachment) => {
         this.store.dispatch(new EmailAttachmentRemoved(file.uId, this.messageId));
      });
   }

   public onSelect(ev: SelectEvent): void {
      ev.files.forEach((file: FileInfo) => {
         if (file.rawFile) {
            const reader = new FileReader();
            reader.onloadend = () => {
               const result = reader.result;
               if (result instanceof ArrayBuffer) {
                  const arrayBuffer = result;
                  const byteArray = new Uint8Array(arrayBuffer);
                  const base64String = arrayBufferToBase64(arrayBuffer);

                  this.store.dispatch(
                     new EmailAttachmentAdded(
                        {
                           binaryContent: base64String,
                           fileSize: byteArray.length,
                           name: file.name,
                           uId: file.uid,
                        },
                        this.messageId
                     )
                  );
               } else {
                  console.error('Unexpected FileReader result type:', typeof result);
               }
            };

            reader.readAsArrayBuffer(file.rawFile);
         }
      });
   }

   public onRemove(ev: RemoveEvent): void {
      ev.files.forEach((file: FileInfo) => {
         this.store.dispatch(new EmailAttachmentRemoved(file.uid, this.messageId));
      });
   }

   public onUploadButtonClick(upload: UploadComponent) {
      upload.fileSelect.nativeElement.click();
   }

   public enableHovered(ev: Event) {
      ev.preventDefault();
      this.counter++;
      this.dropZoneHovered$ = of(true);
   }

   public disableHovered() {
      this.counter--;
      if (this.counter === 0) {
         this.dropZoneHovered$ = of(false);
      }
   }

   public onDrop(ev: Event) {
      this.counter = 0;
      this.dropZoneHovered$ = of(false);
   }

   public onCancel() {
      this.uploadCanceled.emit(true);
   }
}
